import { EUserRole } from '@/enums/EUserRole';

const getUserRoleName = (role: EUserRole): string => {
  switch (role) {
    case EUserRole.Admin:
      return 'Customer Service';
    case EUserRole.Employee:
      return 'Commercial Team';
    case EUserRole.Manager:
      return 'Super User';
    case EUserRole.Warehouse:
      return 'Warehouse';
    case EUserRole.Collector:
      return 'Collector';
    case EUserRole.Observe:
      return 'Observe';
    case EUserRole.Driver:
      return 'Driver';
    default:
      return '';
  }
};

const getUserRoleOptions = () =>
  Object.entries(EUserRole)
    .filter(c => c[1] != EUserRole.SuperAdmin)
    .map(([value]) => ({
      label: getUserRoleName(value as EUserRole),
      value: value as EUserRole,
    }));

export { getUserRoleName, getUserRoleOptions };
